import { render } from "./snackbarComponent.vue?vue&type=template&id=5ee8e0f9&scoped=true&lang=pug"
import script from "./snackbarComponent.vue?vue&type=script&lang=js"
export * from "./snackbarComponent.vue?vue&type=script&lang=js"

import "./snackbarComponent.vue?vue&type=style&index=0&id=5ee8e0f9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ee8e0f9"]])

export default __exports__